"use strict";

exports.__esModule = true;
exports.CalendarEventConfigInfo = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _core = require("@blueprintjs/core");
var _PlantStateActivities = require("../../PlantStateActivities");
var _dec, _class, _CalendarEventConfigInfo;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var WEEKDAY_NAMES = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
var LOCALE_WEEKDAY_NAMES = Array.from({
  length: 7
}, function (_, i) {
  return new Date(1970, 0, i + 5).toLocaleString(undefined, {
    weekday: "long"
  });
});
var CalendarEventConfigInfo = exports.CalendarEventConfigInfo = (_dec = _PlantStateActivities.PlantStateActivitiesContext.withContext, (0, _styledComponents.withTheme)(_class = _dec(_class = (_CalendarEventConfigInfo = /*#__PURE__*/function (_Component) {
  function CalendarEventConfigInfo() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(CalendarEventConfigInfo, _Component);
  var _proto = CalendarEventConfigInfo.prototype;
  _proto.render = function render() {
    var eventConfig = this.props.eventConfig;
    var occursWeekly = eventConfig.occursWeekly.reduce(function (items, day, index, all) {
      items.push(/*#__PURE__*/_react["default"].createElement("em", {
        key: day
      }, LOCALE_WEEKDAY_NAMES[WEEKDAY_NAMES.indexOf(day)]));
      if (index !== all.length - 1) {
        items.push(", ");
      }
      return items;
    }, []);
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, this.renderClassification(), " ", eventConfig.type, " ", /*#__PURE__*/_react["default"].createElement("strong", null, eventConfig.payload.name), " occurs weekly on", " ", occursWeekly, " between ", eventConfig.from, " and ", eventConfig.to, "."));
  };
  _proto.renderClassification = function renderClassification() {
    var _this$props = this.props,
      allPlantStateActivities = _this$props.plantStateActivities,
      eventConfig = _this$props.eventConfig,
      theme = _this$props.theme;
    var plantStateActivities = (0, _PlantStateActivities.getEnabledPlantStateActivities)(allPlantStateActivities);
    if (eventConfig.type !== "Classification" || !eventConfig.payload.state) {
      return;
    }
    var plantState = (0, _PlantStateActivities.getPlantState)(plantStateActivities.states, eventConfig.payload.state);
    var backgroundColor = (0, _PlantStateActivities.getPlantStateColor)(theme, eventConfig.payload.state);
    var label = plantState.name;
    if (eventConfig.payload.activity) {
      var activity = (0, _PlantStateActivities.getPlantActivityOrThrow)(plantStateActivities.activities, eventConfig.payload.activity);
      label = label + ": " + activity.name;
    }
    return /*#__PURE__*/_react["default"].createElement(_core.Tag, {
      style: {
        backgroundColor: backgroundColor
      }
    }, label);
  };
  return CalendarEventConfigInfo;
}(_react.Component), _CalendarEventConfigInfo.defaultProps = {
  theme: undefined,
  plantStateActivities: undefined
}, _CalendarEventConfigInfo)) || _class) || _class);